// extracted by mini-css-extract-plugin
export default {"notfound_wrap":"NotFoundPage_notfound_wrap__APDrd","notfound_txt":"NotFoundPage_notfound_txt__O954l"};